import { IAgentSocialLink, IUser, SocialType } from 'shared/models/User'

export const getIsUnderAgent = (user: IUser | null) => Boolean(user?.parent) && !user?.isSelfRegistered

export type ParsedLiveChatUrl = {
  license?: string
  group?: string
}

export const parseLiveChatUrl = (link: string): ParsedLiveChatUrl | null => {
  try {
    const url = new URL(link)
    const host = url.hostname.replace(/^www\./, '')
    const [license, group] = url.pathname.split('/').filter(Boolean)

    if (host !== 'direct.lc.chat' || !license) return null

    return { license, group }
  } catch {
    return null
  }
}

export const isLiveChatLink = (link: string) => parseLiveChatUrl(link) !== null

export const getAgentLiveChatLink = (links: IAgentSocialLink[]) =>
  links.find(item => item.socialType === SocialType.Other && Boolean(item.link) && isLiveChatLink(item.link))?.link

const getHost = (link: string) => {
  try {
    return new URL(link).hostname.replace(/^www\./, '')
  } catch {
    return null
  }
}

export const isActivosBlackLink = (link: string) => {
  const host = getHost(link)
  return host === 'activosblack.com' || Boolean(host?.endsWith('.activosblack.com'))
}

export const getAgentActivosBlackLink = (links: IAgentSocialLink[]) => {
  const other = links.find(item => item.socialType === SocialType.Other)

  if (other) return other.link && isActivosBlackLink(other.link) ? other.link : undefined

  return links.find(item => item.socialType === SocialType.ActivosBlack && Boolean(item.link))?.link
}

export const getIsLiveChatDisabled = (isAuth: boolean, links: IAgentSocialLink[]) =>
  !isAuth || (Boolean(getAgentActivosBlackLink(links)) && !getAgentLiveChatLink(links))
